import { ButtonHTMLAttributes, ReactNode } from 'react';
import Tooltip from './Tooltip';

type Color = 'default' | 'primary' | 'success' | 'danger' | 'warning' | 'white';

const colorClasses: Record<Color, string> = {
    default: 'text-[var(--eb-text-muted)] hover:bg-[var(--eb-bg)] hover:text-[var(--eb-text)]',
    primary: 'text-[var(--eb-primary)] hover:bg-[var(--eb-primary-soft)]',
    success: 'text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/20',
    danger: 'text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20',
    warning: 'text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/20',
    white: 'text-white/80 hover:bg-white/15 hover:text-white',
};

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    color?: Color;
    size?: number;
    tooltip?: ReactNode;
}

/**
 * Bouton icône — remplace MUI IconButton + antd Tooltip.
 */
const IconButton = ({ color = 'default', size = 36, tooltip, className = '', children, ...rest }: IconButtonProps) => {
    const btn = (
        <button
            className={`inline-flex items-center justify-center rounded-lg transition-colors duration-150
                focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--eb-primary)]
                disabled:opacity-40 disabled:cursor-not-allowed disabled:pointer-events-none
                ${colorClasses[color]} ${className}`}
            style={{ width: size, height: size }}
            {...rest}
        >
            {children}
        </button>
    );
    return tooltip ? <Tooltip title={tooltip}>{btn}</Tooltip> : btn;
};

export default IconButton;
